<div
  class="ss-toggle-button"
  role="radiogroup">
    <label
      class="ss-toggle-button__option"
      [ngClass]="{'is-active': activeLabel === labelOne}"
      (click)="onToggleClick(labelOne)">
      <input
        type="radio"
        [name]="nameLabelOne"
        [id]="idLabelOne"
        [checked]="activeLabel === labelOne">
        {{labelOne}}
    </label>
    <label
      class="ss-toggle-button__option"
      [ngClass]="{'is-active': activeLabel === labelTwo}"
      (click)="onToggleClick(labelTwo)">
      <input
        type="radio"
        [name]="nameLabelTwo"
        [id]="idLabelTwo"
        [checked]="activeLabel === labelTwo">
        {{labelTwo}}
    </label>
</div>
